/**
 * Notify the native webview shell of a logout. Host-owned (the SDK stays
 * platform-agnostic): wire this from an `auth-changed` subscriber on a real
 * `authenticated → anonymous` transition, not the fetch error path. The SDK's
 * `interceptor.beforeError` now owns the 401 → clear-session → `auth-changed`
 * flow (no cookie-name knowledge or page reload here).
 */
export function logoutPwa() {
	if (window.webkit?.messageHandlers?.callbackHandler) {
		window.webkit.messageHandlers.callbackHandler.postMessage({
			logout: 'logoutUser',
		});
	} else if (
		window.IxiWebView &&
		typeof window.IxiWebView.logoutUser === 'function'
	) {
		window.IxiWebView.logoutUser();
	}
}
